<template>
    <div
        class="modal fade modal-completion"
        :id="'aideCompletionModal' + module"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-body shadow">
                    <p class="font-14 font-weight-500">
                        Nous vous invitons à sélectionner la ou les cases
                        relatives à votre situation puis à indiquer le montant
                        correspondant.
                    </p>
                    <section
                        class="modal-completion-section"
                        v-for="(listePrimes, catIndex) in categories"
                        v-if="
                            listePrimes.filter((v) =>
                                modules[module].includes(v)
                            ).length
                        "
                    >
                        <h4>{{ labels.categories[catIndex] }}</h4>
                        <ul class="noBullet modal-completion-list">
                            <li
                                v-for="prime in listePrimes"
                                v-if="modules[module].includes(prime)"
                            >
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        :id="
                                            'input-prime-' + prime.toLowerCase()
                                        "
                                        :checked="montantsPrimes[prime]"
                                        @change="
                                            montantsPrimes[prime] =
                                                !montantsPrimes[prime]
                                        "
                                    />
                                    <label
                                        :for="
                                            'input-prime-' + prime.toLowerCase()
                                        "
                                        class="form-check-label modal-completion-label"
                                    >
                                        <strong>{{ prime }}</strong>
                                        <span>{{ labels.primes[prime] }}</span>
                                    </label>
                                </div>
                                <input
                                    v-if="montantsPrimes[prime]"
                                    v-model="montantsPrimes[prime]"
                                    type="number"
                                    placeholder="Montant (en €)"
                                    class="form-control modal-completion-montant"
                                />
                            </li>
                        </ul>
                    </section>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn_secondary"
                        data-dismiss="modal"
                    >
                        Annuler
                    </button>
                    <button
                        type="button"
                        class="btn btn_primary"
                        data-dismiss="modal"
                        @click="remplirModule"
                    >
                        Valider
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        module: String,
    },
    data() {
        return {
            montantsPrimes: {
                "3PM": null,
                AMJGEND: null,
                AMJGENDMAJ: null,
                BETON: null,
                BSPP: null,
                COMIEM: null,
                COMPCSG: null,
                CSIHIA: null,
                DIFF: null,
                DIFF23: null,
                DIFFSMIC: null,
                DPSD: null,
                ENQPRIX: null,
                GENLANG: null,
                GENDVOL: null,
                ICORSE: null,
                ICS: null,
                ICT: null,
                IE2R: null,
                IEM: null,
                IFRGEND: null,
                IGAR: null,
                IME: null,
                INDEXDEG: null,
                ISHR: null,
                ISSP: null,
                LANG: null,
                MAINTIND: null,
                MAITRAPP: null,
                MAJFORCE: null,
                MITDEC: null,
                MITESC: null,
                MITFOR: null,
                MITHAN: null,
                MITISS: null,
                MITNBI: null,
                MITSPEC: null,
                MITSPECI: null,
                MITSUJ: null,
                MONTGEND: null,
                MUSI12: null,
                MUSI36: null,
                MUSI78: null,
                NBI: null,
                NBIRESI: null,
                NBISUFA: null,
                PCRM: null,
                PCSMIL: null,
                PERF: null,
                PFEU: null,
                POPJ: null,
                PSGEND: null,
                QAL04: null,
                RECHCRIMGN: null,
                REGIS: null,
                REPRES: null,
                RESPO: null,
                SECCIV: null,
                TRADA: null,
            },
            categories: {
                alloc: ["AMJGEND", "MAITRAPP"],
                bonif: ["MITNBI", "NBI", "NBISUFA"],
                compl: ["COMIEM", "CSIHIA"],
                indem: [
                    "BETON",
                    "BSPP",
                    "COMPCSG",
                    "DIFF",
                    "DIFF23",
                    "DIFFSMIC",
                    "DPSD",
                    "ENQPRIX",
                    "GENDVOL",
                    "ICORSE",
                    "ICS",
                    "ICT",
                    "IE2R",
                    "IEM",
                    "IFRGEND",
                    "IGAR",
                    "IME",
                    "INDEXDEG",
                    "ISHR",
                    "ISSP",
                    "LANG",
                    "MITISS",
                    "MITSPECI",
                    "MONTGEND",
                    "MUSI12",
                    "MUSI36",
                    "NBIRESI",
                    "PFEU",
                    "RECHCRIMGN",
                    "REGIS",
                    "REPRES",
                    "RESPO",
                    "SECCIV",
                    "TRADA",
                ],
                major: ["AMJGENDMAJ", "MAINTIND", "MAJFORCE"],
                prime: [
                    "3PM",
                    "GENLANG",
                    "MITDEC",
                    "MITESC",
                    "MITFOR",
                    "MITHAN",
                    "MITSPEC",
                    "MITSUJ",
                    "MUSI78",
                    "PCRM",
                    "PCSMIL",
                    "PERF",
                    "POPJ",
                    "PSGEND",
                    "QAL04",
                ],
            },
            labels: {
                categories: {
                    alloc: "Allocations",
                    bonif: "Bonifactions",
                    compl: "Compléments",
                    indem: "Indemnités",
                    major: "Majorations",
                    prime: "Primes",
                },
                primes: {
                    "3PM": "Prime de parcours professionnels",
                    AMJGEND:
                        "Allocation de mission judiciaire  de la gendarmerie",
                    AMJGENDMAJ:
                        "Majoration de l'allocation de mission judiciaire  de la gendarmerie",
                    BETON: "Indemnité pour travail dans les souterrains non aménagés ou sous béton",
                    BSPP: "Indemnité spéciale de la brigade de sapeurs-pompiers de Paris",
                    COMIEM: "Complémént de l'indemnité d'état militaire",
                    COMPCSG:
                        "Indemnité compensatrice de la hausse de la contribution sociale généralisée dans la fonction publique",
                    CSIHIA: "Complément de solde indiciaire alloué aux militaires des hôpitaux des armées",
                    DIFF: "Indemnité différentielle des officiers issus des sous-officiers qui bénéficiaient de la prime de qualification ou de la prime de service majorée des militaires infirmiers et techniciens des hôpitaux des armées",
                    DIFF23: "Indemnité différentielle des officiers issus des sous-officiers qui bénéficiaient de la prime de parcours professionnel",
                    DIFFSMIC: "Indemnité différentielle SMIC",
                    DPSD: "Indemnité d'activité opérationnelle de la direction de la protection et de la sécurité de défense",
                    ENQPRIX: "Indemnité des enquêteurs de prix",
                    GENLANG:
                        "Prime de langue étrangère des militaires non officiers des brigades de gendarmerie frontière",
                    GENDVOL:
                        "Indemnité spéciale des volontaires dans la gendarmerie nationale",
                    ICORSE: "Indemnité compensatoire pour frais de transport en Corse",
                    ICS: "Indemnité de contrainte spécifique",
                    ICT: "Indemnité compensatrice transitoire Fin 31/12/2032",
                    IE2R: "Indemnité d'entretien, de retouche et de regalonnage",
                    IEM: "Indemnité d'état militaire",
                    IFRGEND:
                        "Indemnité de fonction et de responsabilités des militaires de la gendarmerie nationale",
                    IGAR: "Indemnité de garnison des militaires",
                    IME: "Indemnité pour mission exclusive des militaires du groupe d'intervention de la gendarmerie nationale",
                    INDEXDEG:
                        "Indemnité dégressive allouée à certains fonctionnaires, aux militaires à solde mensuelle ainsi qu'aux magistrats de l'ordre judiciaire",
                    ISHR: "Indemnité spécifique de haute responsabilité",
                    ISSP: "Indemnité de sujétions spéciales de police",
                    LANG: "Indemnité pour connaissances spéciales en langues étrangères",
                    MAINTIND:
                        "Maintien de l'indice précédemment maintenu dans un autre corps",
                    MAITRAPP:
                        "Allocation forfaitaire des maîtres d'apprentissage",
                    MAJFORCE:
                        "Majoration de traitement allouée à certains militaires de la médecine des forces",
                    MITDEC: "Prime spéciale de dédut de carrière des militaires infirmiers et techniciens des hôpitaux des armées",
                    MITESC: "Prime d'exercice en soins critiques",
                    MITFOR: "Prime forfaitaire des militaires infirmiers et techniciens des hôpitaux des armées",
                    MITHAN: "Prime spéciale des infirmiers anesthésistes des hôpitaux des armées",
                    MITISS: "Indemnité de sujétion spéciale des militaires infirmiers et techniciens des hôpitaux des armées",
                    MITNBI: "Nouvelle bonification indiciaire des militaires infirmiers et techniciens des hôpitaux des armées",
                    MITSPEC:
                        "Prime spécifique des militaires infirmiers et techniciens des hôpitaux des armées",
                    MITSPECI:
                        "Indemnité  spécifique des militaires infirmiers et techniciens des hôpitaux des armées",
                    MITSUJ: "Prime spéciale de sujétion des militaires infirmiers et techniciens des hôpitaux des armées",
                    MONTGEND: "Indemnité exclusive de secours en montagne",
                    MUSI12: "Indemnité spéciale aux chefs de musique et aux chefs d'orchestre de la garde républicaine, à l'emploi de chef des orchestres de la garde républicaine",
                    MUSI36: "Indemnité spéciale aux chefs de musique adjoints, chefs adjoints des orchestres et sous-chefs de musique, aux musiciens de tous grades, aux musiciens hors classe, aux musiciens hors classe dernier échelon",
                    MUSI78: "Prime de 1er ou 2e soliste",
                    NBI: "Nouvelle bonification indiciaire",
                    NBIRESI:
                        "Indemnité de résidence afférente à la nouvelle bonification indiciaire",
                    NBISUFA:
                        "Supplément familial de solde afférent à la nouvelle bonification indiciaire",
                    PCRM: "Prime de commandement et de responsabilité militaire",
                    PCSMIL: "Prime de compétence spécifique des militaires",
                    PERF: "Prime de performance",
                    PFEU: "Indemnité spéciale pour risques du personnel du bataillon des marins pompiers de la ville de Marseille",
                    POPJ: "Prime liée à l'exercice des attributions d'OPJ",
                    PSGEND: "Prime spéciale de gendarmerie",
                    QAL04: "Prime de qualification des praticiens des armées",
                    RECHCRIMGN:
                        "Indemnité d'expertise (institut de recherche criminelle de la gendarmerie nationale)",
                    REGIS: "Indemnité de responsabilité des régisseurs d'avances et de recettes",
                    REPRES: "Indemnité pour frais de représentation",
                    RESPO: "Indemnité de responsabilité pécuniaire",
                    SECCIV: "Indemnité spéciale allouée au personnel des formations militaires de la sécurité civile",
                    TRADA: "Indemnité pour travaux dangereux",
                },
            },
            modules: [
                null,
                [
                    "MAITRAPP",
                    "MONTGEND",
                    "PCSMIL",
                    "RECHCRIMGN",
                    "REPRES",
                    "RESPO",
                ],
                [
                    "BETON",
                    "BSPP",
                    "COMIEM",
                    "CSIHIA",
                    "DPSD",
                    "ENQPRIX",
                    "GENDVOL",
                    "GENLANG",
                    "ICORSE",
                    "ICS",
                    "IE2R",
                    "IFRGEND",
                    "IME",
                    "INDEXDEG",
                    "ISHR",
                    "ISSP",
                    "LANG",
                    "MAJFORCE",
                    "MITDEC",
                    "MITESC",
                    "MITFOR",
                    "MITHAN",
                    "MITNBI",
                    "MUSI12",
                    "MUSI36",
                    "MUSI78",
                    "NBI",
                    "NBIRESI",
                    "NBISUFA",
                    "PCRM",
                    "PERF",
                    "PFEU",
                    "REGIS",
                    "SECCIV",
                    "TRADA",
                ],
                [
                    "3PM",
                    "AMJGEND",
                    "AMJGENDMAJ",
                    "COMPCSG",
                    "DIFF",
                    "DIFF23",
                    "DIFFSMIC",
                    "ICT",
                    "IEM",
                    "IGAR",
                    "MAINTIND",
                    "MITISS",
                    "MITSPEC",
                    "MITSPECI",
                    "MITSUJ",
                    "POPJ",
                    "PSGEND",
                    "QAL04",
                ],
            ],
        };
    },
    methods: {
        calculSomme() {
            var somme = 0;
            for (var i = 0; i < this.modules[this.module].length; i++) {
                var montant = parseFloat(
                    this.montantsPrimes[this.modules[this.module][i]]
                );

                if (isNaN(montant)) {
                    continue;
                }

                somme += montant;
            }

            return somme > 0 ? somme : "";
        },
        remplirModule() {
            let moduleEl = null;
            switch (this.module) {
                case "1":
                    moduleEl = document.getElementById(
                        "module1[module1PrimesRecurrIndemBrut]"
                    );
                    break;

                case "2":
                    moduleEl = document.getElementById(
                        "module2[module2PrimesRecurrMaintBrut]"
                    );
                    break;

                case "3":
                    moduleEl =
                        document.getElementById(
                            "module3Mil[module3PrimesAccessDeclaMil][module3PrimesAccessDeclaMilBrut]"
                        ) ??
                        document.getElementById(
                            "module3Cdef[module3PrimesAccessTraitementDeclaCdef][module3PrimesAccessTraitementDeclaCdefBrut]"
                        ) ??
                        document.getElementById(
                            "module3Cdef[module3PrimesAccessSalaireDeclaCdef][module3PrimesAccessSalaireDeclaCdefBrut]"
                        );
                    break;
            }

            if (moduleEl) {
                moduleEl.value = this.calculSomme();
                moduleEl.dispatchEvent(new Event("change"));
            }
        },
    },
};
</script>
